// Version : 1.0.0
// Author : AGALYA

import arrearCollectionActionTypes from './arrear-Collection.types';

/** ***************** GET MEMBER LOAN INFO START *********************** */
export const fetchArrearMemberLoanInfoStart = (getData: any) => ({
	type: arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_START,
	payload: getData,
});

export const fetchArrearMemberLoanInfoSuccess = (successData: any) => ({
	type: arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_SUCCESS,
	payload: successData,
});

export const fetchArrearMemberLoanInfoFailure = (failureData: unknown) => ({
	type: arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_FAILURE,
	payload: failureData,
});

export const fetchArrearMemberLoanInfoResponseResetStart = () => ({
	type: arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_RESPONSE_RESET,
});

export const fetchArrearMemberLoanInfoResponseChanged = () => ({
	type: arrearCollectionActionTypes.GET_ARREAR_LOAN_LIST_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER LOAN INFO END *********************** */

/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */
export const updateArrearCollectionApproveStart = (getData: any) => ({
	type: arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_START,
	payload: getData,
});

export const updateArrearCollectionApproveSuccess = (successData: any) => ({
	type: arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_SUCCESS,
	payload: successData,
});

export const updateArrearCollectionApproveFailure = (failureData: unknown) => ({
	type: arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_FAILURE,
	payload: failureData,
});

export const updateArrearCollectionApproveResponseResetStart = () => ({
	type: arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_RESET,
});

export const updateArrearCollectionApproveResponseChanged = () => ({
	type: arrearCollectionActionTypes.UPDATE_ARREAR_COLLECTION_APPROVE_RESPONSE_CHANGED,
});
/** ***************** UPDATE ARREAR COLLECTION APPROVE END *********************** */

/** ***************** UPDATE COMMON LOAN PAID DETAILS START *********************** */
export const updateCommonLoanPaidDetailsStart = (getData: any) => ({
	type: arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_START,
	payload: getData,
});

export const updateCommonLoanPaidDetailsSuccess = (successData: any) => ({
	type: arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_SUCCESS,
	payload: successData,
});

export const updateCommonLoanPaidDetailsFailure = (failureData: unknown) => ({
	type: arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_FAILURE,
	payload: failureData,
});

export const updateCommonLoanPaidDetailsResponseResetStart = () => ({
	type: arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_RESET,
});

export const updateCommonLoanPaidDetailsResponseChanged = () => ({
	type: arrearCollectionActionTypes.UPDATE_COMMON_LOAN_PAID_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE COMMON LOAN PAID DETAILS END *********************** */
